import { createAction, props } from '@ngrx/store'
import { ILiberatedAreaFilterCriteria } from './liberated-area.reducers'

const SOURCE = '[Liberated Area]'

export const resetLiberatedAreaFilterCriteria = createAction(`${ SOURCE } ResetLiberatedAreaFilterCriteria`)

export const resetLiberatedAreaItemCollection = createAction(`${ SOURCE } ResetLiberatedAreaItemCollection`)

export const setLiberatedAreaFilterCriteria = createAction(
    `${ SOURCE } SetLiberatedAreaFilterCriteria`,
    props<{filterCriteria: ILiberatedAreaFilterCriteria}>()
)

export const setLiberatedAreaItemCollection = createAction(
    `${ SOURCE } SetLiberatedAreaItemCollection`,
    props<{itemCollection: any}>()
)

export const setLiberatedAreaAllItemCollection = createAction(
    `${ SOURCE } SetLiberatedAreaAllItemCollection`,
    props<{allItemCollection: any}>()
)

export const updateFilterCriteria = createAction(
    `${ SOURCE } UpdateFilterCriteria`,
    props<{filterCriteriaFragment: any}>()
)

export const updateFilterCriteriaAndFilter = createAction(
    `${ SOURCE } UpdateFilterCriteriaAndFilter`,
    props<{filterCriteriaFragment: any}>()
)

export const noAction = createAction(`${ SOURCE } No Action`)

// --- effects

export const filter = createAction(`${ SOURCE } Filter`)

export const setStoredOrDefaultCriteria = createAction(`${ SOURCE } SetStoredOrDefaultCriteria`)

export const loadAllLiberatedAreas = createAction(`${ SOURCE } LoadAllLiberatedAreas`)